import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export class FormHelper {
	public static getParentControl(control: AbstractControl): UntypedFormGroup | UntypedFormArray | null {
		return control.parent;
	}

	public static getSiblingControl(control: AbstractControl, columnName: string): AbstractControl {
		return this.getParentControl(control)?.controls[columnName];
	}
}
